import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cards: [
      {
        title: 'Simple Sissy Roulette',
        image: 'https://i.imgur.com/AfQxdal.jpg',
        route: 'simpleSissy',
        color: 'brown',
        desc: 'A Simple Roulette that will dress you from head to toe!'
      },
      {
        title: 'Sissy Selfie Roulette',
        image: 'https://i.imgur.com/UBJchsd.jpg',
        route: 'sissySelfie',
        color: 'black',
        desc: "Get dressed up and find out where you're sharing yourself!"
      },
      {
        title: 'Sissy Shave Roulette',
        image: 'https://i.imgur.com/mu3rBDn.jpg',
        route: 'shavingRoulette',
        color: 'light-blue lighten-4',
        desc: "Time to clean up that sissy clitty!"
      },
      {
        title: 'Weekend Roulette',
        image: 'https://i.imgur.com/qdDZ1pV.jpg',
        route: 'sissyWeekend',
        color: 'green',
        desc: "Roll for how you'll be spending your weekend as a sissy girl!"
      },
      {
        title: 'Anal Domme Roulette',
        image: 'https://i.imgur.com/uElQ5Xx.jpg',
        route: 'analdomme',
        color: 'black',
        desc: 'A Simple Roulette that will dress you from head to toe!'
      },
      {
        title: 'TS Porn Roulette',
        image: 'https://i.imgur.com/JfJxauF.jpg',
        route: 'tspornroulette',
        color: 'blue',
        desc: "Roll for the porn you'll be jerking off to today!"
      },
      {
        title: 'Celebrity Bracket',
        image: 'https://i.imgur.com/j4Khrtm.jpg',
        route: 'celebBracket',
        color: 'red',
        desc: "Elimination Bracket Style! Pick your favorite celebrity!"
      },
      {
        title: 'Playmate Bracket',
        image: 'https://i.imgur.com/60q6Sm1.jpg',
        route: 'playmateBracket',
        color: 'grey',
        desc: "Elimination Bracket Style! Pick your favorite playmate!"
      },
      {
        title: 'Fap Cards',
        image: 'https://i.imgur.com/lHuAMnr.jpg',
        route: 'fapCards',
        color: 'orange',
        desc: "Randomly draw cards and perform tasks until you get to cum!"
      },
      {
        title: 'Sissy Bingo',
        image: 'https://i.imgur.com/uzM6E0Q.jpg',
        route: 'sissyBingo',
        color: 'purple',
        desc: "Blow dildos, fuck your ass, and wear panties! Complete tasks until you get to cum!"
      },
      {
        title: 'X-Change Maze',
        image: 'https://i.imgur.com/Rn80pTV.jpg',
        route: 'transformationMaze',
        color: 'pink',
        desc: 'Make your way through a maze, picking up transformations along the way!'
      }
    ],
    searchedCards: [],
    activeBattleCardsDeck: [
      {
        title: 'Deep Throat',
        src: 'https://i.imgur.com/gTDukct.jpg',
        modifiers: [0, 1, 1, 0],
        cost: 1,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/w2QeCjC.gif', 'https://i.imgur.com/Td1vb2V.gif'],
        desc: 'Gain 1 Def, 1 Atk',
        set: 'Base',
        id: '2749cfe7-1d82-4cfd-8473-a60274571f5a'
      },
      {
        title: 'Cock Worship',
        src: 'https://i.imgur.com/T98ZWTX.jpg',
        modifiers: [1, 0, 0, 0],
        cost: 1,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/iOwA3cU.gif', 'https://i.imgur.com/Y0qhnKr.gif'],
        desc: 'Draw 1 card',
        set: 'Base',
        id: '17ee2c1c-14df-4678-9de1-8591e5868804'
      },
      {
        title: 'Cock Worship',
        src: 'https://i.imgur.com/T98ZWTX.jpg',
        modifiers: [1, 0, 0, 0],
        cost: 1,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/iOwA3cU.gif', 'https://i.imgur.com/Y0qhnKr.gif'],
        desc: 'Draw 1 card',
        set: 'Base',
        id: '1d730e30-0424-44eb-91f7-86061b348b08'
      },
      {
        title: 'Cock Worship',
        src: 'https://i.imgur.com/T98ZWTX.jpg',
        modifiers: [1, 0, 0, 0],
        cost: 1,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/iOwA3cU.gif', 'https://i.imgur.com/Y0qhnKr.gif'],
        desc: 'Draw 1 card',
        set: 'Base',
        id: '058e97d3-6434-42c5-b440-180e2b9059f6'
      },
      {
        title: 'Commando',
        src: 'https://i.imgur.com/XwTUKgt.jpg',
        modifiers: [0, 0, 2, 0],
        cost: 1,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/zF4U8n2.gif', 'https://i.imgur.com/i7sFftZ.gif'],
        desc: 'Gain 2 Atk',
        set: 'Base',
        id: '78dad0d6-566d-41b9-8c51-7e2c5c3cf06d'
      },
      {
        title: 'Commando',
        src: 'https://i.imgur.com/XwTUKgt.jpg',
        modifiers: [0, 0, 2, 0],
        cost: 1,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/zF4U8n2.gif', 'https://i.imgur.com/i7sFftZ.gif'],
        desc: 'Gain 2 Atk',
        set: 'Base',
        id: 'ad30e996-2719-4d43-a3c2-79829fb366b6'
      },
      {
        title: 'Innocence',
        src: 'https://i.imgur.com/MhziJMb.jpg',
        modifiers: [0, 2, 0, 0],
        cost: 1,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/frRjbzp.gif'],
        desc: 'Gain 2 Def',
        set: 'Base',
        id: '40014eaf-a747-4b92-bf78-7fc2a8b3eda6'
      },
      {
        title: 'Innocence',
        src: 'https://i.imgur.com/MhziJMb.jpg',
        modifiers: [0, 2, 0, 0],
        cost: 1,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/frRjbzp.gif'],
        desc: 'Gain 2 Def',
        set: 'Base',
        id: '8a7357e4-00eb-465e-9aca-35ff66796ac3'
      },
      {
        title: 'Onesie',
        src: 'https://i.imgur.com/UMGD1SW.jpg',
        modifiers: [0, 3, 0, 0],
        cost: 2,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/Nt3Jzxp.gif'],
        desc: 'Gain 3 Def',
        set: 'Base',
        id: 'c7229ce6-3fc2-455d-9ee7-1d7198d349b1'
      },
      {
        title: 'Strike A Pose',
        src: 'https://i.imgur.com/dzxR4Rz.jpg',
        modifiers: [0, 0, 0, 2],
        cost: 0,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/i4qt6c0.gif', 'https://i.imgur.com/n60Sedr.gif'],
        desc: 'Gain 2 Cost Points',
        set: 'Base',
        id: 'e3b6fe11-836b-4519-ad06-0ded98cd00ca'
      },
      {
        title: 'All Fours',
        src: 'https://i.imgur.com/MsYmQZb.jpg',
        modifiers: [0, -2, 0, 3],
        cost: 0,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/rHO5FlE.gif', 'https://i.imgur.com/X90QSRK.gif'],
        desc: 'Lose 2 Def, Gain 3 Atk',
        set: 'Base',
        id: '3d069a6b-7d07-4c32-97a9-2e4cc10590df'
      },
      {
        title: 'All Fours',
        src: 'https://i.imgur.com/MsYmQZb.jpg',
        modifiers: [0, -2, 0, 3],
        cost: 0,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/rHO5FlE.gif', 'https://i.imgur.com/X90QSRK.gif'],
        desc: 'Lose 2 Def, Gain 3 Atk',
        set: 'Base',
        id: '1fe8d9d0-aaed-4b75-9fc4-2fffdea61827'
      },
      {
        title: 'All Fours',
        src: 'https://i.imgur.com/MsYmQZb.jpg',
        modifiers: [0, -2, 0, 3],
        cost: 0,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/rHO5FlE.gif', 'https://i.imgur.com/X90QSRK.gif'],
        desc: 'Lose 2 Def, Gain 3 Atk',
        set: 'Base',
        id: '45e474c6-21be-4281-b0e8-8759f0e85a94'
      },
      {
        title: 'Lingerie',
        src: 'https://i.imgur.com/HeJgrKQ.jpg',
        modifiers: [0, 0, 0, 3],
        cost: 0,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/kf1eHYI.gif', 'https://i.imgur.com/liGNpty.gif'],
        desc: 'Gain 3 Cost Points',
        set: 'Base',
        id: '94603de1-430c-424f-bedc-898c2af3d700'
      },
      {
        title: 'Cock Tease',
        src: 'https://i.imgur.com/LXM7AMj.jpg',
        modifiers: [0, 0, 5, 0],
        cost: 3,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/88kylV3.gif', 'https://i.imgur.com/UUivB0n.gif'],
        desc: 'Gain 5 Atk',
        set: 'Base',
        id: 'fa0a362a-6912-446f-948e-b8691940f73d'
      },
      {
        title: 'Facial',
        src: 'https://i.imgur.com/9oAJnvN.jpg',
        modifiers: [0, 3, 1, 0],
        cost: 3,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/xyUh8an.gif', 'https://i.imgur.com/anZlW7N.gif'],
        desc: 'Gain 3 Def, 1 Atk',
        set: 'Base',
        id: '317147c8-9e0d-46c7-acf2-08c0c0429833'
      },
      {
        title: 'Gang Meeting',
        src: 'https://i.imgur.com/n3lwFgj.jpg',
        modifiers: [0, 5, 0, 0],
        cost: 3,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/fXviP75.gif', 'https://i.imgur.com/fra4mqg.gif'],
        desc: 'Gain 5 Def',
        set: 'Base',
        id: 'a3854293-dcf4-4d27-b734-7a0d4b711dbd'
      },
      {
        title: 'Gang Meeting',
        src: 'https://i.imgur.com/n3lwFgj.jpg',
        modifiers: [0, 5, 0, 0],
        cost: 3,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/fXviP75.gif', 'https://i.imgur.com/fra4mqg.gif'],
        desc: 'Gain 5 Def',
        set: 'Base',
        id: '105989f6-d840-4f11-8926-e034307bdda8'
      },
      {
        title: 'Flash',
        src: 'https://i.imgur.com/KNbAoeX.jpg',
        modifiers: [2, 0, 0, 0],
        cost: 2,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/3nr1slO.gif', 'https://i.imgur.com/lCwLnb0.gif'],
        desc: 'Draw 2 Cards',
        set: 'Base',
        id: '10b375c1-ae6b-4004-b022-90c7ce8c6310'
      },
      {
        title: 'Foreplay',
        src: 'https://i.imgur.com/6BaZlV3.jpg',
        modifiers: [0, 0, 0, 1],
        cost: 0,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/7DYNiLR.gif', 'https://i.imgur.com/ZZiGLce.gif'],
        desc: 'Gain 1 Cost Point',
        set: 'Base',
        id: '4877e430-966d-48f6-9269-f2a7ce2529d2'
      },
      {
        title: 'Foreplay',
        src: 'https://i.imgur.com/6BaZlV3.jpg',
        modifiers: [0, 0, 0, 1],
        cost: 0,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/7DYNiLR.gif', 'https://i.imgur.com/ZZiGLce.gif'],
        desc: 'Gain 1 Cost Point',
        set: 'Base',
        id: '8e48e807-e9d4-4825-8e6e-bd910f352f52'
      },
      {
        title: 'Foreplay',
        src: 'https://i.imgur.com/6BaZlV3.jpg',
        modifiers: [0, 0, 0, 1],
        cost: 0,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/7DYNiLR.gif', 'https://i.imgur.com/ZZiGLce.gif'],
        desc: 'Gain 1 Cost Point',
        set: 'Base',
        id: 'ff0589c2-65eb-4eec-b582-ca9d22a6cd92'
      },
      {
        title: 'Foreplay',
        src: 'https://i.imgur.com/6BaZlV3.jpg',
        modifiers: [0, 0, 0, 1],
        cost: 0,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/7DYNiLR.gif', 'https://i.imgur.com/ZZiGLce.gif'],
        desc: 'Gain 1 Cost Point',
        set: 'Base',
        id: 'bae89daf-dd7d-41cc-aaf2-79c63c9ee4f1'
      },
      {
        title: 'Foreplay',
        src: 'https://i.imgur.com/6BaZlV3.jpg',
        modifiers: [0, 0, 0, 1],
        cost: 0,
        color: 'pink darken-2',
        gifs: ['https://i.imgur.com/7DYNiLR.gif', 'https://i.imgur.com/ZZiGLce.gif'],
        desc: 'Gain 1 Cost Point',
        set: 'Base',
        id: 'c8689a83-7daf-4206-b969-55f929d5a4d4'
      },
    ],
    battleCardsBDSM:[
      {
        title: 'Cuffed',
        src: 'https://i.imgur.com/n78eE8t.jpg',
        modifiers: [0, 6, 0, 0],
        cost: 1,
        color: 'red darken-4',
        desc: 'Gain 6 Def',
        set: 'BDSM',
        id: '2fb8332c-03bf-411f-8f5f-95e5d24d5695'
      },
      {
        title: 'Cuffed',
        src: 'https://i.imgur.com/n78eE8t.jpg',
        modifiers: [0, 6, 0, 0],
        cost: 1,
        color: 'red darken-4',
        desc: 'Gain 6 Def',
        set: 'BDSM',
        id: '8aaaf800-ba6f-45ee-81b3-a9ede1520554'
      },
      {
        title: 'Cuffed',
        src: 'https://i.imgur.com/n78eE8t.jpg',
        modifiers: [0, 6, 0, 0],
        cost: 1,
        color: 'red darken-4',
        desc: 'Gain 6 Def',
        set: 'BDSM',
        id: '8ef9a124-547e-4ca6-80b4-fb8fa462a84d'
      },
      {
        title: 'Cuffed',
        src: 'https://i.imgur.com/n78eE8t.jpg',
        modifiers: [0, 6, 0, 0],
        cost: 1,
        color: 'red darken-4',
        desc: 'Gain 6 Def',
        set: 'BDSM',
        id: '85ddde75-3874-4bbc-a4a6-b72001f986c1'
      },
      {
        title: 'Free Use',
        src: 'https://i.imgur.com/jFnlYbc.jpg',
        modifiers: [0, 8, 0, 0],
        cost: 2,
        color: 'red darken-4',
        desc: 'Gain 8 Def',
        set: 'BDSM',
        id: 'cf39abe3-5384-4f98-b1b0-0b9b3454a00f'
      },
      {
        title: 'Free Use',
        src: 'https://i.imgur.com/jFnlYbc.jpg',
        modifiers: [0, 8, 0, 0],
        cost: 2,
        color: 'red darken-4',
        desc: 'Gain 8 Def',
        set: 'BDSM',
        id: '1a0eb0a4-cac7-434e-aa95-3ad09a98918b'
      },
      {
        title: 'Free Use',
        src: 'https://i.imgur.com/jFnlYbc.jpg',
        modifiers: [0, 8, 0, 0],
        cost: 2,
        color: 'red darken-4',
        desc: 'Gain 8 Def',
        set: 'BDSM',
        id: 'fdbe9e94-99f5-4103-93b6-6132ba385215'
      },
      {
        title: 'Bound Blowjob',
        src: 'https://i.imgur.com/NOH0Srn.jpg',
        modifiers: [0, 0, 5, 0],
        cost: 3,
        color: 'red darken-4',
        desc: 'Gain 5 Atk',
        set: 'BDSM',
        id: 'ea24c4da-899f-4f26-b854-4948e87a38ae'
      },
      {
        title: 'Bound Blowjob',
        src: 'https://i.imgur.com/NOH0Srn.jpg',
        modifiers: [0, 0, 5, 0],
        cost: 3,
        color: 'red darken-4',
        desc: 'Gain 5 Atk',
        set: 'BDSM',
        id: '27a33be9-d8ab-4ec3-b760-e86876e76eda'
      },
      {
        title: 'Bound Blowjob',
        src: 'https://i.imgur.com/NOH0Srn.jpg',
        modifiers: [0, 0, 5, 0],
        cost: 3,
        color: 'red darken-4',
        desc: 'Gain 5 Atk',
        set: 'BDSM',
        id: '9224f2da-cb85-43a9-a8f1-06bb3b0aa14e'
      },
      {
        title: 'Hard Caning',
        src: 'https://i.imgur.com/Z8Uh8Tr.jpg',
        modifiers: [0, 0, 8, 0],
        cost: 5,
        color: 'red darken-4',
        desc: 'Gain 8 Atk',
        set: 'BDSM',
        id: '4e5dfc06-e874-49f5-a883-9fd30a2b5af8'
      },
      {
        title: 'Hard Caning',
        src: 'https://i.imgur.com/Z8Uh8Tr.jpg',
        modifiers: [0, 0, 8, 0],
        cost: 5,
        color: 'red darken-4',
        desc: 'Gain 8 Atk',
        set: 'BDSM',
        id: '272ccea8-f595-4956-8333-d2f7a509d31e'
      },
    ],
    battleCardsBimbo: [
      {
        title: 'Shopping Spree',
        src: 'https://i.imgur.com/PbO97cU.jpg',
        modifiers: [4, 0, 0, 0],
        cost: 10,
        color: 'green lighten-2',
        desc: 'Draw 4 Cards',
        set: 'Bimbo',
        id: '68cd22c8-7598-469d-b2f1-1bfc3c755dc4'
      },
      {
        title: 'Fake Tits',
        src: 'https://i.imgur.com/WoPDp2Y.jpg',
        modifiers: [0, 2, 0, 0],
        cost: 10,
        color: 'green lighten-2',
        desc: 'Permanently Gain 2 Def',
        set: 'Bimbo',
        id: 'c76b3646-67e9-4bc8-a6e5-874cad98a1c4'
      },
      {
        title: 'Plump Lips',
        src: 'https://i.imgur.com/RwIY7rP.jpg',
        modifiers: [0, 1, 0, 0],
        cost: 8,
        color: 'green lighten-2',
        desc: 'Permanently Gain 1 Def',
        set: 'Bimbo',
        id: '118471e2-f294-4d35-b3a0-17c4a43229c4'
      },
      {
        title: 'Plump Lips',
        src: 'https://i.imgur.com/RwIY7rP.jpg',
        modifiers: [0, 1, 0, 0],
        cost: 8,
        color: 'green lighten-2',
        desc: 'Permanently Gain 1 Def',
        set: 'Bimbo',
        id: '86a9c1ea-90a6-48d9-b74e-3f755b14adde'
      },
      {
        title: 'Bimbo Blowjob',
        src: 'https://i.imgur.com/LWRJhrm.jpg',
        modifiers: [0, 0, 5, 0],
        cost: 3,
        color: 'green lighten-2',
        desc: 'Gain 5 Attack',
        set: 'Bimbo',
        id: '45303213-2d43-4ab2-8bfb-4f703e0ede5b'
      },
      {
        title: 'Bimbo Blowjob',
        src: 'https://i.imgur.com/LWRJhrm.jpg',
        modifiers: [0, 0, 5, 0],
        cost: 3,
        color: 'green lighten-2',
        desc: 'Gain 5 Attack',
        set: 'Bimbo',
        id: 'd18e9c61-9738-41dd-87d8-b80b3197b18a'
      },
      {
        title: 'Living Sex Doll',
        src: 'https://i.imgur.com/bHbNBpd.jpg',
        modifiers: [0, 0, 0, 5],
        cost: 0,
        color: 'green lighten-2',
        desc: 'Gain 5 Cost Points',
        set: 'Bimbo',
        id: 'f874813a-4ffe-4ac8-951b-3d9e51630d86'
      },
      {
        title: 'Living Sex Doll',
        src: 'https://i.imgur.com/bHbNBpd.jpg',
        modifiers: [0, 0, 0, 5],
        cost: 0,
        color: 'green lighten-2',
        desc: 'Gain 5 Cost Points',
        set: 'Bimbo',
        id: 'ba3a5b08-5b5a-4488-a2d0-0fe28d109f46'
      },
      {
        title: 'Bimbo Outfit',
        src: 'https://i.imgur.com/jMLMivT.jpg',
        modifiers: [0, 0, 1, 0],
        cost: 8,
        color: 'green lighten-2',
        desc: 'Permanently Gain 1 Attack',
        set: 'Bimbo',
        id: 'dfd85b7f-9339-4379-a76c-36f1866a9c33'
      },
      {
        title: 'Bimbo Outfit',
        src: 'https://i.imgur.com/jMLMivT.jpg',
        modifiers: [0, 0, 1, 0],
        cost: 8,
        color: 'green lighten-2',
        desc: 'Permanently Gain 1 Attack',
        set: 'Bimbo',
        id: 'a4c9e66e-cc46-450c-a3b0-10fb400a2a06'
      },
      {
        title: 'Legs For Days',
        src: 'https://i.imgur.com/8u0SQSU.jpg',
        modifiers: [0, 0, 2, 0],
        cost: 10,
        color: 'green lighten-2',
        desc: 'Permanently Gain 2 Attack',
        set: 'Bimbo',
        id: '81a8492d-c6d1-45ea-b8ae-1f30fa71ecce'
      },
      {
        title: '1000+ CC',
        src: 'https://i.imgur.com/FTud1xt.jpg',
        modifiers: [0, 2, 2, 0],
        cost: 20,
        color: 'green lighten-2',
        desc: 'Permanently Gain 2 Attack and 2 Def',
        set: 'Bimbo',
        id: 'cae8c999-61ce-4eed-b67e-73ee9b1aa857'
      },
    ],
    battleCardsLimited: [
      {
        title: 'Latex Bimbo',
        src: 'https://i.imgur.com/Tdkbmq1.jpg',
        modifiers: [3, 3, 3, 0],
        cost: 15,
        color: 'pink accent-2',
        desc: 'Permanently Gain 2 Attack and 2 Def, Draw 3 cards',
        set: 'Limited',
        id: '92002b41-d78e-4c36-b63c-487534abf03a'
      }
    ],
    battleCardsUnused: [],
    battleCardsDrawn: [],
    points: 0,
  },
  mutations: {
    searchCards (state, searchString){
      console.log("Search Mutation Hit with string " + searchString);
      state.searchedCards = state.cards.filter(function(card){
        return card.title.toLowerCase().includes(searchString);
      });
      console.log(state.searchedCards);
    },
    battleCardsAlterDeck(state, payload){
      state.activeBattleCardsDeck = payload.newActiveBattleCardsDeck;
      state.battleCardsUnused = payload.newBattleCardsUnused;
    },
    drawCards(state, payload){
      state.battleCardsDrawn = [];
      if(payload.set == 'BDSM'){
        state.battleCardsBDSM = payload.drawSet;
      }
      if(payload.set == 'Bimbo'){
        state.battleCardsBimbo = payload.drawSet;
      }
      payload.drawnArr.forEach(card => {
        state.battleCardsUnused.push(card);
        state.battleCardsDrawn.push(card);
      });
      if(state.battleCardsBDSM.length == 0 && state.battleCardsBimbo.length == 0){
        state.battleCardsUnused.push(state.battleCardsLimited.find(card => card.id == '92002b41-d78e-4c36-b63c-487534abf03a'));
      }
    },
    addPoints(state, points){
      state.points += points;
    }
  },
  actions: {
    searchCards({commit}, searchString){
      commit('searchCards', searchString);
    },
    battleCardsRemoveFromDeck({commit}, cardId){
      let payload = {
        newBattleCardsUnused: this.state.battleCardsUnused,
        newActiveBattleCardsDeck: []
      }
      payload.newBattleCardsUnused.push(this.state.activeBattleCardsDeck.find(card => card.id == cardId));
      payload.newActiveBattleCardsDeck = this.state.activeBattleCardsDeck.filter(x => {
        return x.id != cardId;
      })
      commit('battleCardsAlterDeck', payload);
    },
    battleCardsAddToDeck({commit}, cardId){
      let payload = {
        newBattleCardsUnused: [],
        newActiveBattleCardsDeck: this.state.activeBattleCardsDeck
      }
      payload.newActiveBattleCardsDeck.push(this.state.battleCardsUnused.find(card => card.id == cardId));
      payload.newBattleCardsUnused = this.state.battleCardsUnused.filter(x => {
        return x.id != cardId;
      })
      commit('battleCardsAlterDeck', payload);
    },
    drawCards({commit}, set){
      let drawSet = new Array;
      if(set == 'BDSM'){
        drawSet = this.state.battleCardsBDSM;
      }
      if(set == 'Bimbo'){
        drawSet = this.state.battleCardsBimbo;
      }
      let drawnArr = new Array;
      for (let i = 0; i < 4; i++) {
        var drawnCard = drawSet[Math.floor(Math.random()*drawSet.length)];
        console.log(drawnCard.id);
        let newDrawArr = drawSet.filter(card => {
          return card.id != drawnCard.id;
        });
        drawSet = newDrawArr;
        console.log(drawSet.length);
        drawnArr.push(drawnCard);
      }
      let payload = {
        set: set,
        drawSet: drawSet,
        drawnArr: drawnArr
      }
      console.log(payload.drawnArr);
      commit('drawCards', payload);
    },
    calculateWinPoints({commit}, round){
      let points = 0;
      if(round <= 20){
        points = 15;
      } else if(round <= 40){
        points = 10;
      } else {
        points = 5;
      }
      commit('addPoints', points);
    }
  },
  modules: {
  }
})
